export const companyName = 'TBZ Engineering';
export const companyWebsite = 'https://tbz.com.bd';
export const companyEmail = 'info@tbz.com.bd';
export const companyMobile = '+801710000001';
export const roleValue = {
  super_admin: 'Super Admin',
  admin: 'Admin',
  user: 'User',
};

export const txTypes = ['Refill', 'Consumption'];

export const allMonths = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];
export const tableCells = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15];

export const monthList = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];

export const weekDays = [
  'Saturday',
  'Sunday',
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
];

export const yearList = [
  '2021',
  '2022',
  '2023',
  '2024',
  '2025',
  '2026',
  '2027',
  '2028',
  '2029',
  '2030',
];
export const mainStatus = ['Due', 'Partial', 'Paid'];
export const quotationStatus = [
  { id: 'New', title: 'Draft' },
  { id: 'Sent_To_Client', title: 'Sent To Client' },
  { id: 'Accepted', title: 'Accepted' },
  { id: 'Declined', title: 'Declined' },
  { id: 'Analyze_Decline', title: 'Analyze Decline' },
];

export const genders = ['Male', 'Female'];
export const bloodGroups = ['A+', 'B+', 'AB+', 'O+', 'A-', 'B-', 'AB-', 'O-'];
export const keywords = [
  'MAINTENANCE EXPENSE',
  'OPERATION EXPENSE',
  'MASTER SERVICE',
  'OTHER MAINTENANCE',
  'ROUTINE SERVICE',
  'DRIVER SALARY',
  'FUEL EXPENSE',
];

export const termCond =
  "<ol><li>Product will be delivered within <strong>02 (two)</strong> working days after the purchase order, subject to product availability.</li><li>This offer is valid for <strong>02 (two)</strong> days excluding the day of offer submission.</li><li>Delivery will be made from our <strong>Elephant Road showroom</strong>.</li><li>Free carry in service will be provided as per warranty declaration in the above.</li><li>Extra charges are applicable for service support at the client's office premises.</li><li>All prices are inclusive of govt applicable VAT &amp; Tax.</li></ol>";
